import createIcon from '../../createIcon';

/**
 * @component @name Transcribe
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuOTcgMTYuNUwxOS42IDE0Ljg3QzE2LjgzIDExLjg1IDE2LjgzIDcuMzEgMTkuNiA0LjEzTDE3Ljk3IDIuNUMxNC4wNyA2LjM5IDE0LjA2IDEyLjQ1IDE3Ljk3IDE2LjVaTTIyLjk2IDExLjQ1QzIyLjEyIDEwLjI3IDIyLjEyIDguNzQgMjIuOTYgNy41NkwyMS4yOCA1Ljg3QzE5LjI2IDcuODkgMTkuMjYgMTAuOTQgMjEuMjggMTMuMTRMMjIuOTYgMTEuNDVaTTkuMDQwMDQgMTMuNUMxMS4yNSAxMy41IDEzLjA0IDExLjcxIDEzLjA0IDkuNUMxMy4wNCA3LjI5IDExLjI1IDUuNSA5LjA0MDA0IDUuNUM2LjgzMDA0IDUuNSA1LjA0MDA0IDcuMjkgNS4wNDAwNCA5LjVDNS4wNDAwNCAxMS43MSA2LjgzMDA0IDEzLjUgOS4wNDAwNCAxMy41Wk0xNS40MyAxNi4wNkMxMy43NSAxNS4yIDExLjU3IDE0LjUgOS4wNDAwNCAxNC41QzYuNTEwMDQgMTQuNSA0LjMzMDA0IDE1LjIgMi42NTAwNCAxNi4wNkMxLjY1MDA0IDE2LjU3IDEuMDQwMDQgMTcuNiAxLjA0MDA0IDE4LjcyVjIxLjVIMTcuMDRWMTguNzJDMTcuMDQgMTcuNiAxNi40MyAxNi41NyAxNS40MyAxNi4wNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Transcribe = createIcon('Transcribe', [
  [
    'path',
    {
      d: 'M17.97 16.5L19.6 14.87C16.83 11.85 16.83 7.31 19.6 4.13L17.97 2.5C14.07 6.39 14.06 12.45 17.97 16.5ZM22.96 11.45C22.12 10.27 22.12 8.74 22.96 7.56L21.28 5.87C19.26 7.89 19.26 10.94 21.28 13.14L22.96 11.45ZM9.04004 13.5C11.25 13.5 13.04 11.71 13.04 9.5C13.04 7.29 11.25 5.5 9.04004 5.5C6.83004 5.5 5.04004 7.29 5.04004 9.5C5.04004 11.71 6.83004 13.5 9.04004 13.5ZM15.43 16.06C13.75 15.2 11.57 14.5 9.04004 14.5C6.51004 14.5 4.33004 15.2 2.65004 16.06C1.65004 16.57 1.04004 17.6 1.04004 18.72V21.5H17.04V18.72C17.04 17.6 16.43 16.57 15.43 16.06Z',
      key: '1ljiot',
    },
  ],
]);

export default Transcribe;
